import API from '@apis/client';
import { AxiosResponse } from 'axios';
import {
  CartCreatePayload,
  getCartListPayload,
  getMyStockListPayload,
  patchStockItemPayload,
  StockCreateEtcPayload,
  StockCreatePayload,
} from 'models/Supplement';
import { CommonAxiosErrorType } from 'models/SupplementType';
import {
  StockGetStockCategoriesError,
  StockHistoryCreateStockItemHistoryData,
  StockHistoryCreateStockItemHistoryError,
  StockHistoryCreateStockItemHistoryPayload,
  StockHistoryGetStockItemHistoryListData,
  StockHistoryGetStockItemHistoryListError,
  StockHistoryGetStockItemHistoryListPayload,
  StockSearchSearchStockItemHistoryData,
  StockSearchSearchStockItemHistoryError,
  StockSearchSearchStockItemHistoryPayload,
} from 'modules/swagger/data-contracts';
import {
  GetStockItemDetailData,
  GetStockItemDetailError,
  OpenStockAddressGetLastStockAddressData,
  OpenStockAddressGetLastStockAddressError,
  OpenStockCloseStockItemData,
  OpenStockCloseStockItemError,
  OpenStockCloseStockItemPayload,
  OpenStockOpenStockItemData,
  OpenStockOpenStockItemError,
  OpenStockPutIsLikeStockItemData,
  OpenStockPutIsLikeStockItemError,
  OpenStockSearchOpenStockItemData,
  OpenStockSearchOpenStockItemError,
  OpenStockSearchOpenStockItemPayload,
  OpenStockUpdateStockItemData,
  OpenStockUpdateStockItemError,
  OpenStockViewTypeReadData,
  OpenStockViewTypeReadError,
  OpenStockViewTypeUpdateData,
  OpenStockViewTypeUpdateError,
  StockAutocompleteAutocompleteItemCodeData,
  StockAutocompleteAutocompleteItemCodeError,
  StockAutocompleteAutocompleteItemCodePayload,
  StockCreateData,
  StockDeleteStockItemData,
  StockDeleteStockItemError,
  StockDeleteStockItemPayload,
  StockGetMyStockItemDetailData,
  StockGetMyStockItemDetailError,
  StockGetStandardCodesData,
  StockGetStandardCodesError,
  StockGetStandardCodesPayload,
  StockPostStockItemsBatchData,
  StockPostStockItemsBatchPayload,
} from 'models/swagger/data-contracts';
import { StockGetOptionsPayload } from 'models/swagger/data-contracts';
import { StockCreateError } from 'models/swagger/data-contracts';
import { StockGetStockCategoriesData } from 'models/swagger/data-contracts';
import { StockGetStockProductTypesData } from 'models/swagger/data-contracts';
import { StockGetStockProductTypesPayload } from 'models/swagger/data-contracts';
import { StockGetStockProductTypesError } from 'models/swagger/data-contracts';
import { StockGetStockCategoriesPayload } from 'models/swagger/data-contracts';
import { StockGetOptionsData, StockGetOptionsError, StockSearchStockItemError } from 'models/swagger/data-contracts';
import {
  CartCreateData,
  CartCreateError,
  CartReadData,
  CartReadError,
  ProductGetProductTypeData,
  StockAutocompleteAutocompleteMaterialGradeData,
  StockAutocompleteAutocompleteMaterialGradeError,
  StockAutocompleteAutocompleteMaterialGradePayload,
  StockDeleteData,
  StockDeleteError,
  StockDeletePayload,
  StockDeleteStockBulkData,
  StockDeleteStockBulkError,
  StockDeleteStockBulkPayload,
  StockPartialUpdateData,
  StockPartialUpdateError,
  StockPostStockEtcData,
  StockPostStockEtcError,
  StockReadData,
  StockSearchStockItemData,
  StockSearchStockItemPayload,
} from 'models/swagger/data-contracts';
import { StockSearchAllSearchAllStockItemHistoryPayload } from 'models/swagger/data-contracts';
import { StockSearchAllSearchAllStockItemHistoryData } from 'models/swagger/data-contracts';
import { StockSearchAllSearchAllStockItemHistoryError } from 'models/swagger/data-contracts';

/**
 * 재고 등록 가능한 제품 타입들을 조회한다.
 * @function getStockProductTypeApi
 */
export const getStockProductTypeApi = (): Promise<AxiosResponse<ProductGetProductTypeData, CommonAxiosErrorType>> => {
  return API.get('/product/stock/product_type');
};

/**
 *  개인창고 리스트 가져오기 API
 *  @function getMyStockListApi
 */
export const getMyStockListApi = ({
  cursor,
}: getMyStockListPayload): Promise<AxiosResponse<StockReadData, CartReadError>> => {
  return API.get(`/stock/?cursor=${cursor}&limit=99`);
};

/**
 *  개인창고 담기 API
 *  @function createCartItemApi
 *  @param {number} product product
 *  @param {string} size1 size1
 *  @param {string} size2 size2
 *  @param {string} end1 end1
 *  @param {string} end2 end2
 *  @param {string} thickness1 thickness1
 *  @param {string} thickness2 thickness2
 *  @param {string} coating coating
 *  @param {string} pressure_rating pressure_rating
 *  @param {string} bonnet_type bonnet_type
 *  @param {string} bore bore
 *  @param {string} stem stem
 *  @param {string} seat seat
 *  @param {string} trim_no trim_no
 *  @param {string} operating_type operating_type
 *  @param {string} disc disc
 *  @param {string} plug plug
 *  @param {number} quantity 수량
 *  @param {number} length 길이 (only PIPE)
 */
export const createMyStockItemApi = ({
  item_code,
  product,
  size1,
  size2,
  end1,
  end2,
  thickness1,
  thickness2,
  coating,
  pressure_rating,
  bonnet_type,
  bore,
  stem,
  seat,
  trim_no,
  operating_type,
  disc,
  plug,
  quantity,
  length,
  standard_code_id,
  product_type_id,
  category_id,
  etc_material_grade_id,
}: StockCreatePayload): Promise<AxiosResponse<StockCreateData, StockCreateError>> => {
  return API.post(`/stock/`, {
    item_code,
    product,
    size1,
    size2,
    end1,
    end2,
    thickness1,
    thickness2,
    coating,
    pressure_rating,
    bonnet_type,
    bore,
    stem,
    seat,
    trim_no,
    operating_type,
    disc,
    plug,
    quantity,
    length,
    standard_code_id,
    product_type_id,
    category_id,
    etc_material_grade_id,
  });
};

/**
 *  장바구니 담기 API (Etc)
 *  @function createMyStockEtcItemApi
 */
export const createMyStockEtcItemApi = ({
  etcArray,
}: {
  etcArray: StockCreateEtcPayload;
}): Promise<AxiosResponse<StockPostStockEtcData, StockPostStockEtcError>> => {
  return API.post(`/stock/etc`, etcArray);
};

/**
 *  장바구니 수량 수정 API
 *  @function patchStockItemApi
 *  @param {number} id id
 *  @param {number} quantity 수량
 */
export const patchStockItemApi = ({
  id,
  quantity,
}: patchStockItemPayload): Promise<AxiosResponse<StockPartialUpdateData, StockPartialUpdateError>> => {
  return API.patch(`/stock/${id}`, { quantity });
};

/**
 *  재고 단일 삭제 API
 *  @function deleteStockItemApi
 */
export const deleteStockItemApi = (
  payload: StockDeleteStockItemPayload,
): Promise<AxiosResponse<StockDeleteStockItemData, StockDeleteStockItemError>> => {
  return API.post(`/stock/delete`, payload);
};

/**
 *  재고 일괄 삭제 API
 *  @function deleteStockBulkApi
 */
export const deleteStockBulkApi = (
  payload: StockDeleteStockBulkPayload,
): Promise<AxiosResponse<StockDeleteStockBulkData, StockDeleteStockBulkError>> => {
  return API.post(`/stock/bulk`, payload);
};

export const getStockAutocompleteMaterialGradeApi = (
  payload: StockAutocompleteAutocompleteMaterialGradePayload,
): Promise<
  AxiosResponse<StockAutocompleteAutocompleteMaterialGradeData, StockAutocompleteAutocompleteMaterialGradeError>
> => {
  return API.post('/stock/autocomplete/material_grade', payload);
};

export const getStockSearchApi = (
  payload: StockSearchStockItemPayload,
): Promise<AxiosResponse<StockSearchStockItemData, StockSearchStockItemError>> => {
  return API.post('/stock/search', payload);
};

export const getStockDetailApi = (
  stock_item_id: number,
): Promise<AxiosResponse<GetStockItemDetailData, GetStockItemDetailError>> => {
  return API.get(`/stock/${stock_item_id}`);
};

export const getMyStockDetailApi = (
  stock_item_id: number,
): Promise<AxiosResponse<StockGetMyStockItemDetailData, StockGetMyStockItemDetailError>> => {
  return API.get(`/stock/my/${stock_item_id}`);
};

export const getStandardCodeInStockApi = (
  payload: StockGetStandardCodesPayload,
): Promise<AxiosResponse<StockGetStandardCodesData, StockGetStandardCodesError>> => {
  return API.post('/stock/standard_code', payload);
};

export const getProductTypeInStockApi = (
  payload: StockGetStockProductTypesPayload,
): Promise<AxiosResponse<StockGetStockProductTypesData, StockGetStockProductTypesError>> => {
  return API.post('/stock/product_type', payload);
};

export const getCategoryInStockApi = (
  payload: StockGetStockCategoriesPayload,
): Promise<AxiosResponse<StockGetStockCategoriesData, StockGetStockCategoriesError>> => {
  return API.post('/stock/category', payload);
};

export const getStockOptionsApi = (
  payload: StockGetOptionsPayload,
): Promise<AxiosResponse<StockGetOptionsData, StockGetOptionsError>> => {
  return API.post('/stock/options', payload);
};

export const postStockItemHistoryCreateApi = (
  payload: StockHistoryCreateStockItemHistoryPayload,
): Promise<AxiosResponse<StockHistoryCreateStockItemHistoryData, StockHistoryCreateStockItemHistoryError>> => {
  return API.post('/stock/history/create', payload);
};

export const getStockItemHistoryListApi = (
  payload: StockHistoryGetStockItemHistoryListPayload,
): Promise<AxiosResponse<StockHistoryGetStockItemHistoryListData, StockHistoryGetStockItemHistoryListError>> => {
  return API.post('/stock/history/list', payload);
};

export const getStockItemHistorySearchApi = (
  payload: StockSearchSearchStockItemHistoryPayload,
): Promise<AxiosResponse<StockSearchSearchStockItemHistoryData, StockSearchSearchStockItemHistoryError>> => {
  return API.post('/stock/search/history', payload);
};

export const getStockItemHistoryAllSearchApi = (
  payload: StockSearchAllSearchAllStockItemHistoryPayload,
): Promise<
  AxiosResponse<StockSearchAllSearchAllStockItemHistoryData, StockSearchAllSearchAllStockItemHistoryError>
> => {
  return API.post('/stock/search/all/history', payload);
};

/**
 * 재고 아이템 코드 자동완성 호출
 *  @function postAutocompleteSearchApi
 */
export const postStockItemCodeAutocompleteApi = (
  props: StockAutocompleteAutocompleteItemCodePayload,
): Promise<AxiosResponse<StockAutocompleteAutocompleteItemCodeData, StockAutocompleteAutocompleteItemCodeError>> => {
  return API.post('stock/autocomplete/item_code', props);
};

/**
 * 재고 오픈 API
 *  @function postOpenStockItemApi
 */
export const postOpenStockItemApi = (
  payload: any,
): Promise<AxiosResponse<OpenStockOpenStockItemData, OpenStockOpenStockItemError>> => {
  return API.post('/open-stock/open', payload);
};

/**
 * 재고 정보 수정 API
 *  @function postUpdateStockItemApi
 */
export const postUpdateStockItemApi = (
  payload: any,
): Promise<AxiosResponse<OpenStockUpdateStockItemData, OpenStockUpdateStockItemError>> => {
  return API.post('/open-stock/update', payload);
};

/**
 * 재고 비공개 API
 *  @function postCloseStockItemApi
 */
export const postCloseStockItemApi = (
  payload: OpenStockCloseStockItemPayload,
): Promise<AxiosResponse<OpenStockCloseStockItemData, OpenStockCloseStockItemError>> => {
  return API.post('/open-stock/close', payload);
};

export const getOpenStockSearchApi = (
  payload: OpenStockSearchOpenStockItemPayload,
): Promise<AxiosResponse<OpenStockSearchOpenStockItemData, OpenStockSearchOpenStockItemError>> => {
  return API.post('/open-stock/search', payload);
};

export const putIsLikeOpenStockItemApi = (
  stock_item_id: number,
  is_like: boolean
): Promise<AxiosResponse<OpenStockPutIsLikeStockItemData, OpenStockPutIsLikeStockItemError>> => {
  return API.put(`/open-stock/like?stock_item_id=${stock_item_id}&is_like=${is_like}`);
};

export const getOpenStockViewTypeApi = (): Promise<AxiosResponse<OpenStockViewTypeReadData, OpenStockViewTypeReadError>> => {
  return API.get('/open-stock/view_type');
};

export const putOpenStockViewTypeApi = (
  stock_view_type: string,
): Promise<AxiosResponse<OpenStockViewTypeUpdateData, OpenStockViewTypeUpdateError>> => {
  return API.put(`/open-stock/view_type?stock_view_type=${stock_view_type}`);
};

export const getLastStockAddressApi = (): Promise<AxiosResponse<OpenStockAddressGetLastStockAddressData, OpenStockAddressGetLastStockAddressError>> => {
  return API.get('/open-stock/address/last');
};

export const createMyStockItemBatchApi = (
  payload: StockPostStockItemsBatchPayload,
): Promise<AxiosResponse<StockPostStockItemsBatchData, StockPostStockEtcError>> => {
  return API.post(`/stock/batch`, payload);
};